import { checkStateHasReportData, useCMAStore } from 'features/CMA/infra/react/CMAState'
import { LotSizeFilterCardDumb } from 'presentation/screens/CompsScreen/components/CompsFilterPanel/components/LotSizeFilterCard/LotSizeFilterCard.dumb'
import { LotSizeFilterCardDumbProps as Props } from 'presentation/screens/CompsScreen/components/CompsFilterPanel/components/LotSizeFilterCard/LotSizeFilterCard.dumb.props'
import { shallow } from 'zustand/shallow'

export const LotSizeFilterCard = () => {
  const isReady = useCMAStore(state =>
    checkStateHasReportData(state.local.report),
  )

  const {
    subjectValue,
    filterValue,
  } = useCMAStore(state => {
    if (!checkStateHasReportData(state.local.report)) {
      return {
        subjectValue: null,
        filterValue: null,
      }
    }

    return {
      subjectValue: state.local.report.data.salesListInfo.subject?.lotAreaSqft ?? null,
      filterValue: state.local.report.data.filters.lotAreaSize,
    }
  }, shallow)
  const filterComps = useCMAStore(state => state.actions.filterComps.execute)

  const handleOnValueChange: Props['onChange'] = filter => {
    void filterComps({
      lotAreaSize: filter,
    })
  }

  if (!isReady) return null

  return (
    <LotSizeFilterCardDumb
      value={filterValue || {
        sqftRange: null,
        unit: 'sqft',
      }}
      onChange={handleOnValueChange}
      subjectValue={subjectValue}
    />
  )
}
